import { createSlice } from "@reduxjs/toolkit";

const loadingSlice = createSlice({
  name: "loading",
  initialState: {
    isGlobalLoading: false
  },
  reducers: {
    setGlobalLoading: (state, action) => {
      state.isGlobalLoading = action.payload;
    }
  }
});

export const { setGlobalLoading } = loadingSlice.actions;

export default loadingSlice.reducer;